"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arrayToObject", {
    enumerable: true,
    get: function() {
        return arrayToObject;
    }
});
function arrayToObject(array, keyField) {
    return array.reduce((obj, item)=>{
        obj[item[keyField]] = item;
        return obj;
    }, {});
}
